"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const Box_1 = __importDefault(require("@material-ui/core/Box"));
const Button_1 = __importDefault(require("@material-ui/core/Button"));
const Card_1 = __importDefault(require("@material-ui/core/Card"));
const Grid_1 = __importDefault(require("@material-ui/core/Grid"));
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const formik_1 = require("formik");
const _1 = require("./");
const DocumentForm = (props) => {
    const { index, documentURL, isEditing, onCancel, onItemSubmit } = props;
    const { values, setFieldError, setFieldTouched } = formik_1.useFormikContext();
    const save = () => {
        const doc = values.documents[index];
        let isValid = true;
        if (doc) {
            setFieldTouched(`documents[${index}].documentURL`, true);
            setFieldTouched(`documents[${index}].name`, true);
            if (!isEditing && !doc.documentURL) {
                setFieldError(`documents[${index}].documentURL`, 'Document URL is required');
                isValid = false;
            }
            if (!doc.name) {
                setFieldError(`documents[${index}].name`, 'Document name is required');
                isValid = false;
            }
            if (!isValid) {
                return;
            }
            if (!isEditing) {
                onItemSubmit(doc.documentURL, doc.name);
            }
            else {
                onItemSubmit(doc.name);
            }
        }
    };
    return (react_1.default.createElement(Card_1.default, null,
        react_1.default.createElement(Box_1.default, { p: 2 },
            react_1.default.createElement(Grid_1.default, { container: true },
                react_1.default.createElement(Grid_1.default, { item: true, xs: 12 },
                    react_1.default.createElement(Typography_1.default, { variant: "subtitle1" }, isEditing ? 'Edit Document Details' : 'Add Document')),
                !isEditing && (react_1.default.createElement(Grid_1.default, { item: true, xs: 12 },
                    react_1.default.createElement(Box_1.default, { my: 1 },
                        react_1.default.createElement(formik_1.FastField, { name: `documents[${index}].documentURL`, component: _1.RenderTextField, label: documentURL ? documentURL : 'Document URL' })))),
                react_1.default.createElement(Grid_1.default, { item: true, xs: 12 },
                    react_1.default.createElement(Box_1.default, { my: 1 },
                        react_1.default.createElement(formik_1.FastField, { name: `documents[${index}].name`, component: _1.RenderTextField, label: "Document Name" }))),
                react_1.default.createElement(Grid_1.default, { item: true, xs: 12, sm: 7 }),
                react_1.default.createElement(Grid_1.default, { item: true, xs: 12, sm: 5 },
                    react_1.default.createElement(Grid_1.default, { container: true },
                        react_1.default.createElement(Grid_1.default, { item: true, xs: 12, sm: 5 }, onCancel && (react_1.default.createElement(Button_1.default, { variant: "contained", color: "secondary", size: "large", onClick: onCancel }, "Cancel"))),
                        react_1.default.createElement(Grid_1.default, { item: true, xs: 12, sm: 7 },
                            react_1.default.createElement(Button_1.default, { variant: "contained", color: "primary", size: "large", onClick: () => save() }, isEditing ? 'Save Changes' : 'Add Document'))))))));
};
DocumentForm.propTypes = {
    index: prop_types_1.default.number.isRequired,
    documentURL: prop_types_1.default.string,
    isEditing: prop_types_1.default.bool,
    onCancel: prop_types_1.default.any,
    onItemSubmit: prop_types_1.default.any,
};
exports.default = DocumentForm;
